import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const PersonaRetargetingCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.PERSONA_RETARGETING}
    visibleOptionalPanels={[CAMPAIGN_STEPS.ROLE_TITLES, CAMPAIGN_STEPS.VISITORS_RETARGETING_SEGMENTS]}
  />
);

export default PersonaRetargetingCreatePageRedesign;
